import { listingRealisationsMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [
  listingRealisationsMock({
    context: 'listing-magasin',
    storeUuid: '1f02ff8b-edcc-60f2-b2f4-efd44f4b8cf1',
    fallbackSuggestions: 'Aucun résultat trouvé.',
  }),
];

export const realisationsClientListingMagasinMock: SlugPage = {
  ...pageBase({
    title: 'Realisations Client - Listing Magasin',
    type: 'realisations',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
